export default function() {
  return {
    entities: {},
    entitiesById: [],
    entityEvents: {},
    entityEventsById: [],
    staticEntities: {},
    staticEntitiesById: [],
  };
}
